// extracted by mini-css-extract-plugin
module.exports = {"root":"GamesList_root_r2yCu"};